import React from 'react';

import SelectItem from './../selects/SelectItem';
import SelectMaterial from './../selects/SelectMaterial';
import { colorsTabletops } from '../../utils/colors';

export default class ModalTableTop extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentOptions: {
                material: '',
                type: '',
                color: '',
                position: '',
                countCup: '',
            },
            options: {
                material: [],
                type: [],
                color: [],
                position: [],
                countCup: [],
            },
            validFields: {
                material: false,
                type: false,
                color: false,
                position: false,
                countCup: false,
            },
        }
    }

    componentDidMount() {
        this._setMaterialOptions();
    }

    componentDidUpdate(prevProps, prevState) {
        if(JSON.stringify(prevState.currentOptions) !== JSON.stringify(this.state.currentOptions)) {
            this._validateFields();
        }
    }
    
    _setMaterialOptions() {
        const copyOptions = JSON.parse(JSON.stringify(this.state.options));
        copyOptions.type = '';
        copyOptions.color = '';
        const newOptionsMaterial = [];
        
        // Перебираем все материалы
        for(let key in colorsTabletops) {
            // Проверяем, есть ли доступные типы для данного материала
            const hasAvailableTypes = Object.keys(colorsTabletops[key].type[0]).some(typeKey => {
                // Проверяем, есть ли этот тип в currentTabletopsList и имеет ли он ненулевую цену
                return this.props.currentTabletopsList[0][typeKey] && 
                       this.props.currentTabletopsList[0][typeKey].price !== 0;
            });

            // Добавляем материал только если есть доступные типы
            if (hasAvailableTypes) {
                newOptionsMaterial.push({
                    value: key,
                    label: colorsTabletops[key].name,
                });
            }
        }

        if(JSON.stringify(copyOptions.material) !== JSON.stringify(newOptionsMaterial)) {
            copyOptions.material = newOptionsMaterial;
            this.setState(state => {
                return {options: copyOptions}
            }, () => this._setPositionOptions())
        }
    }

    _checkTwoCups() {
        return !!this.props.allVariableSink.find(sink => {
            return sink.count_cup === 2
        }) || !!this.props.currentStand.position_sink.find(position => position === 'D')
    }

    _setPositionOptions() {
        const copyOptions = JSON.parse(JSON.stringify(this.state.options));
        const positions = this.props.config.stand.stand.position_sink;
        let newOptionPosition = positions.map(position => {
            return {value: position, label: position === 'L' ? 'Слева' : position === 'R' ? 'Справа' : position === 'C' ? 'Центр' : '', }
        })


        newOptionPosition = newOptionPosition.filter(item => {
            const checkStandPosition = this.props.config.stand.positionStand === false || (this.props.config.stand.positionStand === 'R' && (item.value === 'R' || item.value === 'C') || (this.props.config.stand.positionStand === 'L' && (item.value === 'L' || item.value === 'C')))
            return item.label !== ''  && checkStandPosition ;
        })

        copyOptions.position = newOptionPosition;

        
        this.setState(state => {
            return {options: copyOptions}
        },() => this._setCountCupsOptions());
    }

    _setCountCupsOptions() {
        const copyOptions = JSON.parse(JSON.stringify(this.state.options));
        const copyCurrentOptions = JSON.parse(JSON.stringify(this.state.currentOptions));
        const checkCountCup = this._checkTwoCups();
        let newOptionCountCups = [];
        if(checkCountCup) {
            newOptionCountCups = [
                {
                    value: 1,
                    label: '1',
                },
                {
                    value: 2,
                    label: '2',
                }
            ]
            copyOptions.countCup = newOptionCountCups;
            copyCurrentOptions.countCup = "";
        }
        else {
            copyOptions.countCup = false;
            copyCurrentOptions.countCup = 1;
        }
        this.setState(state => {
            return {
                options: copyOptions,
                currentOptions: copyCurrentOptions
            }
        })
    }
    

    _setTypeOptions() {
        const copyOptions = JSON.parse(JSON.stringify(this.state.options));
        copyOptions.color = '';
        const newOptionsType = [];
        if(this.state.currentOptions.material !== undefined) {
            for(let key in colorsTabletops) {
                if(key === this.state.currentOptions.material) {
                    const colorsTabletopsType = colorsTabletops[key].type[0];
                    for(let key in colorsTabletopsType) {
                        newOptionsType.push(
                            {
                                value: key,
                                label: colorsTabletopsType[key].name.replace('Матовая эмаль', 'Керамогранит категории A').replace('Глянцевая эмаль', 'Керамогранит категории B'),
                            }
                        )
                    }
                }
            }
        }


        let filterCopyType;
        const types = newOptionsType;
        if(types) {
            filterCopyType = types.filter(type => {
                return this.props.currentTabletopsList[0][type.value].price !== 0; 
            })
        }

        if(JSON.stringify(copyOptions.type) !== JSON.stringify(filterCopyType)) {
            const copyCurrentOptions = JSON.parse(JSON.stringify(this.state.currentOptions));
            copyCurrentOptions.type = '';
            copyOptions.type = filterCopyType;
            this.setState(state => {
                return {
                    currentOptions: copyCurrentOptions,
                    options: copyOptions
                }
            })
        }
    }

    _setColorOptions() {
        const copyOptions = JSON.parse(JSON.stringify(this.state.options));
        let colorArray;
        if(this.state.currentOptions.material) {
            colorArray = colorsTabletops[this.state.currentOptions.material].type[0][this.state.currentOptions.type].colors;
        }
        else {
            colorArray = false;
        }
       
        if(colorArray === false || this.state.currentOptions.type === undefined) {
            const copyCurrentOptions = JSON.parse(JSON.stringify(this.state.currentOptions));
            copyOptions.color = [];
            copyCurrentOptions.color = null;
            this.setState(state => {
                return {
                    currentOptions: copyCurrentOptions,
                    options: copyOptions
                }
            })
        }
        else {
            const newOptionsColor = [];
            for(let i = 0; i < colorArray.length; i++) {
                newOptionsColor.push({
                    value: colorArray[i].color,
                    label: <div><span>{`${colorArray[i].name}`}</span><img src={colorArray[i].img}/></div>
                })
            }
            if(JSON.stringify(copyOptions.color) !== JSON.stringify(newOptionsColor)) {
                const copyCurrentOptions = JSON.parse(JSON.stringify(this.state.currentOptions));
                copyCurrentOptions.color = '';
                copyOptions.color = newOptionsColor;
                this.setState(state => {
                    return {
                        currentOptions: copyCurrentOptions,
                        options: copyOptions
                    }
                })
            }
        }
    }

    setMaterial(value) {
        const copyOptions = JSON.parse(JSON.stringify(this.state.currentOptions))
        if(value) {
            copyOptions.material = value.value;
            this.setState(state => {
                return {
                    currentOptions: copyOptions,
                }
            }, () => {
                this._setTypeOptions();
            })
        }
    }
    

    setType(value) {
        if(value && value.value !== '') {
            const copyOptions = JSON.parse(JSON.stringify(this.state.currentOptions))
            copyOptions.type = value.value;
            this.setState(state => {
                return {
                    currentOptions: copyOptions,
                }
            }, () => {
                this._setColorOptions();
                this.props.updatePrice(this._searchTabletop().price + (this.state.currentOptions.countCup === 2 ? 3530 : 0))
            })
        }
        
    }

    setColor(value) {
        if(value) {
            const copyOptions = JSON.parse(JSON.stringify(this.state.currentOptions))
            copyOptions.color = value.value;
            this.setState(state => {
                return {
                    currentOptions: copyOptions,
                }
            })
        }
    }

    setPosition(value) {
        if(value) {
            const copyOptions = JSON.parse(JSON.stringify(this.state.currentOptions))
            copyOptions.position = value.value;
            this.setState(state => {
                return {
                    currentOptions: copyOptions
                }
            })
        }
    }

    setCountCup(value) {
        if(value) {
            const copyOptions = JSON.parse(JSON.stringify(this.state.currentOptions))
            if(value.value === 1) {
                copyOptions.countCup = value.value;
                copyOptions.position = "";
            }
            else {
                copyOptions.countCup = value.value;
                copyOptions.position = "D";
            }
            

            this.setState(state => {
                return {
                    currentOptions: copyOptions
                }
            }, () => this.state.currentOptions.type !== '' ? this.props.updatePrice(this._searchTabletop().price + (this.state.currentOptions.countCup === 2 ? 3530 : 0)) : '')
        }
    }

    _validateFields() {
        const copyValidateObject = JSON.parse(JSON.stringify(this.state.validFields));
        const currentOptions = this.state.currentOptions;
        for(let key in currentOptions) {
            if(currentOptions[key]!=='' || this.state.options[key] === null) {
                copyValidateObject[key] = true;
            }
            else {
                copyValidateObject[key] = false;
            }
        }
        
        let checkAllValidate = true;

        for(let key in copyValidateObject) {
            if(copyValidateObject[key] === false) {
                checkAllValidate = false;
            }
        }

        if(checkAllValidate) {
            this.props.updateValidate('tabletop', true);
            this._searchTabletop();
        }
        else this.props.updateValidate('tabletop', false);
    
        this.setState(state => {
            return {
                validFields: copyValidateObject,
                allValid: checkAllValidate
            }
        })
    }

    _searchTabletop() {
        const currentTabletopsInfo = {};
        let currentArticle = {};
        const typeTabletops = this.props.currentTabletopsList[this.props.currentTabletopsList.length - 1][this.state.currentOptions.type];
        typeTabletops.codes.forEach(info => {
            this.props.config.stand.stand.counterTops.forEach(code => {
                if(info.code === code) {
                    currentArticle = code;
                }
            })
        });
        currentTabletopsInfo.price = typeTabletops.price;
        currentTabletopsInfo.code = currentArticle;
        return currentTabletopsInfo;
    }

    setTabletop() {
        let copyConfiguration = JSON.parse(JSON.stringify(this.props.srcConfig));
        const article = this._searchTabletop().code;
        copyConfiguration.sink= false;
        copyConfiguration.tabletop = {
            article: article,
            position: this.state.currentOptions.position,
            color: this.state.currentOptions.color === null || this.state.currentOptions.color === '' ? false : this.state.currentOptions.color
        }
        this.props.setConfiguration(copyConfiguration);
    }



    render() {
        return (
            <>
                <div className='modal-window__controls'>
                    {window.innerWidth >= 1200  ? '' : <h2 className='modal-window__controls-title'>Выберите параметры:</h2>}
                </div>
                <div className='modal-window__control modal-window__control--one'>
                    <SelectItem 
                        key="uniq_id2"
                        value = {this.state.currentOptions.material}
                        handleChange = {this.setMaterial.bind(this)} 
                        validate={this.props.validateParts ? this.state.validFields.material : true} 
                        options = {this.state.options.material} placeholder={'Материал'}
                    />
                </div>
                {
                    this.state.options.countCup !== false ?
                    <div className='modal-window__control modal-window__control--one'>
                        <SelectItem 
                            key="uniq_id5"
                            value = {this.state.options.countCup}
                            handleChange = {this.setCountCup.bind(this)} 
                            validate={this.props.validateParts ? this.state.validFields.countCup : true} 
                            options = {this.state.options.countCup} placeholder={'Количество чаш'}
                        />
                    </div>
                    :
                    <></>
                }
                
                {
                    this.state.options.countCup === false || this.state.currentOptions.countCup === 1 ?
                    <div className='modal-window__control modal-window__control--one'>
                        <SelectItem 
                            key="uniq_id4"
                            value = {this.state.currentOptions.position}
                            handleChange = {this.setPosition.bind(this)} 
                            validate={this.props.validateParts ? this.state.validFields.position : true} 
                            options = {this.state.options.position} placeholder={'Позиция выреза'}
                        />
                    </div>
                    :
                    <></>
                }
                
                {
                    this.state.validFields.material ?
                    <div className='modal-window__control modal-window__control--one'>
                        <SelectItem 
                            ref={this.refSelectType}
                            key="uniq_id1"
                            value = {this.state.currentOptions.type}
                            handleChange = {this.setType.bind(this)} 
                            validate={this.props.validateParts ? this.state.validFields.type : true} 
                            options = {this.state.options.type} placeholder={'Вариант столешницы'}
                            name = "type"
                        />
                    </div>
                    :
                    <></>
                }
                
                {
                    this.state.options.color.length !== 0 ?
                    <div className='modal-window__control modal-window__control--one'>
                        <SelectMaterial

                            key="uniq_id3"
                            value = {this.state.currentOptions.color}
                            handleChange = {this.setColor.bind(this)} 
                            validate={this.props.validateParts ? this.state.validFields.color : true} 
                            options = {this.state.options.color} 
                            placeholder={'Цвет'}
                        />
                    </div>
                    :
                    <></>
                }
                
            </>
        )
    }
}